<template>
    <tbody>
      <!-- Sub-Module Row -->
      <tr class="border">
        <td style="text-align: left">
          <input type="checkbox" :id="'module_id_'+ index" :value="parentModule.id" v-model="form.module_permissions" @change="checkModule($event)">
          {{ parentModule.name }}
        </td>
  
        <td>
          <input type="checkbox" :id="'sub_module_id_'+ subModuleIndex" :value="subModule.id" v-model="form.sub_module_permissions" @change="checkSubModule($event)">
          {{ subModule.name }}
        </td>
  
        <!-- Sub-Sub-Modules -->
        <td>
          <div v-if="subModule.sub_modules && subModule.sub_modules.length > 0">
            <input type="checkbox" :id="'sub_sub_module_id_'+ 0" :value="subModule.sub_modules[0].id" v-model="form.sub_sub_module_permissions" @change="checkSubSubModule($event)">
            {{ subModule.sub_modules[0].name }}
          </div>
          <div v-else>
            N/A
          </div>
        </td>
  
        <td>
          <!-- Actions for Sub-Module -->
          <ul class="permission_list" v-if="Array.isArray(subModule.actions) && subModule.actions.length > 0">
            <li v-for="(permission, j) in subModule.actions" :key="j">
              <input type="checkbox" :id="'permission_id'+ j" class="checkbox" :value="permission.id" v-model="form.role_permissions" @change="checkSinglePermission($event)">
              {{ permission.name }}
            </li>
          </ul>
  
          <!-- Actions for First Sub-Sub-Module -->
          <ul v-if="Array.isArray(subModule.sub_modules) && subModule.sub_modules.length > 0 && Array.isArray(subModule.sub_modules[0].actions) && subModule.sub_modules[0].actions.length > 0">
            <li v-for="(permission, j) in subModule.sub_modules[0].actions" :key="j">
              <input type="checkbox" :id="'sub_sub_permission_id'+ j" class="checkbox" :value="permission.id" v-model="form.role_permissions" @change="checkSinglePermission($event)">
              {{ permission.name }}
            </li>
          </ul>
        </td>
      </tr>
  
      <!-- Additional Sub-Sub-Modules -->
      <tr v-for="(sub_sub_module, iSubSub) in (subModule.sub_modules ? subModule.sub_modules.slice(1) : [])" :key="iSubSub">
        <td></td>
        <td></td>
        <td>
          <input type="checkbox" :id="'sub_sub_module_id_'+ iSubSub" :value="sub_sub_module.id" v-model="form.sub_sub_module_permissions" @change="checkSubSubModule($event)">
          {{ sub_sub_module.name }}
        </td>
        <td>
          <ul class="permission_list" v-if="sub_sub_module.actions && sub_sub_module.actions.length > 0">
            <li v-for="(permission, j) in sub_sub_module.actions" :key="j">
              <input type="checkbox" :id="'permission_id_'+ j" :value="permission.id" v-model="form.role_permissions" @change="checkSinglePermission($event)">
              {{ permission.name }}
            </li>
          </ul>
        </td>
      </tr>
    </tbody>
  </template>
  
  <script>
  export default {
    props: {
      parentModule: Object,
      subModule: Object,
      index: Number,
      subModuleIndex: Number,
      form: Object
    },
    methods: {
      checkModule(event) {
        this.$emit('check-module', event);
      },
      checkSubModule(event) {
        this.$emit('check-sub-module', event);
      },
      checkSubSubModule(event) {
        this.$emit('check-sub-sub-module', event);
      },
      checkSinglePermission(event) {
        this.$emit('check-permission', event);
      }
    }
  };
  </script>
  